<script>
import Layout from "@/router/layouts/main";
import { api } from "@/state/services";

const TYPES = [
  { id: 1, name: "Gato" },
  { id: 2, name: "Cachorro" },
  { id: 3, name: "Pássaro" },
  { id: 4, name: "Cavalo" },
  { id: 5, name: "Boi" },
];

export default {
  locales: {
    pt: {},
    es: {},
  },
  components: {
    Layout,
  },
  data() {
    return {
      types: TYPES,

      pets: null,
      limit: null,

      create: {
        modal: false,
        loading: false,
        pet: {
          type: "",
          name: "",
          breed: "",
        },
      },

      remove: {
        modal: false,
        loading: false,
        pet: null,
      },
    };
  },
  methods: {
    getPets() {
      this.pets = null;

      api
        .get("pets")
        .then((response) => {
          if (response.data.status === "success") {
            this.pets = response.data.list;
            this.limit = response.data.limit;
          }
        });
    },
    showCreate() {
      this.create.pet.type = "";
      this.create.pet.name = "";
      this.create.pet.breed = "";
      this.create.modal = false;
      this.create.modal = true;
    },
    createPet() {
      if (!this.create.pet.name || !this.create.pet.breed || !this.create.pet.type) {
        this.$toast.error("Preencha todos os campos do pet.");
        return;
      }

      this.create.loading = true;

      api
        .post("pets", {
          type:    this.create.pet.type,
          name:    this.create.pet.name,
          breed:   this.create.pet.breed,
        })
        .then((response) => {
          if (response.data.status === "success") {
            this.create.pet.type = "";
            this.create.pet.name = "";
            this.create.pet.breed = "";
            this.create.modal = false;
            this.create.loading = false;
            this.$toast.success("Pet cadastrado com sucesso.");
            this.getPets();
          } else {
            this.create.loading = false;
            this.$toast.error(response.data.message);
          }
        })
        .catch(() => {
          this.create.modal = false;
          this.create.loading = false;
        });
    },
    showRemove(pet) {
      this.remove.pet = pet;
      this.remove.modal = true;
    },
    confirmRemove() {
      if (!this.remove.pet) return;

      this.remove.loading = true;

      api
        .delete("pets/" + this.remove.pet.id)
        .then((response) => {
          if (response.data.status === "success") {
            this.remove.modal = false;
            this.remove.loading = false;
            this.remove.pet = null;
            this.$toast.success("O pet foi excluído com sucesso.");
            this.getPets();
          } else {
            this.remove.loading = false;
            this.$toast.error(response.data.message || "Não foi possível excluir o pet.");
          }
        })
        .catch(() => {
          this.remove.modal = false;
          this.remove.loading = false;
        });
    },
  },
  mounted() {
    this.getPets();
  },
};
</script>

<template>
  <Layout>
    <div class="page-title-box d-flex justify-content-between align-items-start mb-3">
      <div>
        <h3>Meus Pets</h3>
        <p>Gerencie os pets cadastrados no seu plano.</p>
      </div>
      <div v-if="pets !== null && limit !== null" class="d-flex align-items-center">
        <span class="badge badge-soft-primary font-size-13 px-3 py-2">
          {{ pets.length }} / {{ limit }} pets
        </span>
      </div>
    </div>

    <div v-if="limit !== null && limit === 0" class="alert alert-warning mb-3 text-center">
      O seu plano não contempla o cadastro de pets.
    </div>

    <div v-else-if="limit !== null && pets !== null && pets.length >= limit" class="alert alert-warning mb-3 text-center">
      Você atingiu o limite de <strong>{{ limit }} pet(s)</strong> do seu plano.
    </div>

    <button class="btn border btn-lg btn-block mb-4" v-on:click="showCreate()" :disabled="limit !== null && (limit === 0 || (pets !== null && pets.length >= limit))">
      Adicionar pet
    </button>

    <div v-if="pets === null" class="text-center">
      <b-spinner variant="default" role="status"></b-spinner>
    </div>

    <div v-else-if="pets && pets.length === 0" class="card">
      <div class="card-body text-center">
        Nenhum pet cadastrado.
      </div>
    </div>

    <div v-else>
      <div class="card mb-2" v-for="(pet, index) in pets" :key="index">
        <div class="card-body d-flex justify-content-between align-items-center">
          <div class="d-flex align-items-center">
            <div>
              <h5 class="m-0 text-dark font-size-16"><strong>{{ pet.name }}</strong></h5>
              <p class="m-0 text-muted font-size-13">
                {{ pet.type }}
                <span v-if="pet.breed"> · {{ pet.breed }}</span>
              </p>
            </div>
          </div>
          <div>
            <button class="btn btn-sm btn-outline-danger" v-on:click="showRemove(pet)">
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" style="fill: currentColor;">
                <path d="M5 20a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8h2V6h-4V4a2 2 0 0 0-2-2H9a2 2 0 0 0-2 2v2H3v2h2zM9 4h6v2H9zM8 8h9v12H7V8z"></path>
                <path d="M9 10h2v8H9zm4 0h2v8h-2z"></path>
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>

    <b-modal v-model="create.modal" modal-class="modal-right" hide-header hide-footer>
      <b-form @submit.prevent="createPet">
        <h4>Adicionar novo pet</h4>
        <p></p>
        <div class="my-5">
          <b-form-group label="Tipo de animal" label-for="pet-type">
            <select id="pet-type" v-model="create.pet.type" class="custom-select" required>
              <option value="" disabled>Selecione o tipo de animal</option>
              <option v-for="type in types" :key="type.id" :value="type.id">
                {{ type.name }}
              </option>
            </select>
          </b-form-group>
          <b-form-group label="Nome" label-for="pet-name">
            <b-form-input
              id="pet-name"
              v-model="create.pet.name"
              type="text"
              required
            ></b-form-input>
          </b-form-group>
          <b-form-group label="Raça" label-for="pet-breed">
            <b-form-input
              id="pet-breed"
              v-model="create.pet.breed"
              type="text"
              required
            ></b-form-input>
          </b-form-group>
        </div>
        <div class="d-flex justify-content-between align-items-center">
          <button class="btn btn-default btn-lg mr-3" type="submit" :disabled="create.loading">
            Adicionar
            <b-spinner v-if="create.loading" small class="ml-2 align-middle" variant="white" role="status"></b-spinner>
          </button>
          <a class="btn btn-outline-link" v-on:click="create.modal = false">Fechar</a>
        </div>
      </b-form>
    </b-modal>

    <b-modal v-model="remove.modal" modal-class="modal-bottom" hide-header hide-footer>
      <div v-if="remove.pet">
        <h4>Excluir Pet</h4>
        <p class="mt-3">
          Tem certeza que deseja excluir o pet <strong>{{ remove.pet.name }}</strong>?
        </p>
        <div class="d-flex justify-content-between align-items-center mt-5">
          <button class="btn btn-danger btn-lg mr-3" v-on:click="confirmRemove()" :disabled="remove.loading">
            Excluir
            <b-spinner v-if="remove.loading" small class="ml-2 align-middle" variant="white" role="status"></b-spinner>
          </button>
          <a class="btn btn-outline-link" v-on:click="remove.modal = false">Cancelar</a>
        </div>
      </div>
    </b-modal>
  </Layout>
</template>
